<template>
  <div>
    <van-row class="bmForm">
      <van-col span="24">
			<h3 class="bmlcTit">填写学分信息 <van-icon class="iconfont" class-prefix="icon" name="bianji" size="24" color="#e5b91c" /></h3>
          	<van-notice-bar style="font-size: 16px;" v-if="meeting.scoreDeadline">
          	 温馨提示：学分申请截止日期{{meeting.scoreDeadline.substring(0,10)}}。
          	  <template #left-icon>
          	    <van-icon name='info-o' size="20" style="margin-right: 10px;" />
          	  </template>
          	</van-notice-bar>
              <van-col span="24">
          		<van-form @submit="onSubmit_xf">
          			<div class="formInput hide">
          			<van-field
          			  v-model="attr2.enteredId"
          			  :value="attr2.enteredId"
          			  name="enteredId"
          			/>
          			</div>
                <div class="formInput">
                  <van-field
                    v-model="attr2.name"
                    :value="attr2.name"
                    name="name"
                    placeholder="请填写姓名"
                    label="姓名"
                    clearable
                    required
                    :rules="[{ required: true, message: '请填写姓名' }]"
                  />
                </div>
                <div class="formInput">
                  <van-field
                    v-model="attr2.age"
          		  :value="attr2.age"
                    name="age"
                    placeholder="请填写年龄"
                    label="年龄"
                    maxlength='3'
                    type="digit"
                    clearable
                    required
                    :rules="[{ required: true, message: '请填写年龄' }]"
                  />
                </div>
                <div class="formInput">
                  <van-field
                			
                    name="sex"
                    label="性别"
                    required
                  >
                    <template #input>
                      <van-radio-group v-model="attr2.sex" direction="horizontal">
                        <van-radio name="男">男</van-radio>
                        <van-radio name="女">女</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                </div>
                <div class="formInput">
                  <van-field
                			
                    v-model="attr2.titlegrade"
                    is-link
                    readonly
                    name="titlegrade"
                    label="职称"
                    placeholder="请选择职称"
                    required
                    @click="showPicker_titlegrade = true"
                    :rules="[{ required: true, message: '请选择职称' }]"
                  />
                  <van-popup v-model:show="showPicker_titlegrade" position="bottom">
                    <van-picker
                    show-toolbar
                      :columns="columns_titlegrade"
                      @confirm="onConfirm_titlegrade"
                      @cancel="showPicker_titlegrade = false"
                    />
                  </van-popup>
                </div>
                <div class="formInput">
                  <van-field
                			
                    v-model="attr2.gzdw"
                    name="gzdw"
                    placeholder="请填写单位标准全称"
                    label="工作单位"
                    clearable
                    required
                    :rules="[{ required: true, message: '请填写单位标准全称' }]"
                  />
                </div>
                <!-- <div class="formInput">
                  <van-field
                			
                    v-model="unitlocation"
                    name="unitlocation"
                    placeholder="请填写单位所在地"
                    label="单位所在地"
                    clearable
                    required
                    :rules="[{ required: true, message: '请填写单位所在地' }]"
                  />
                </div> -->
                <!-- <div class="formInput">
                  <van-field
                			
                    v-model="titlegrade"
                    name="titlegrade"
                    placeholder="请填写职称"
                    label="职称"
                    clearable
                    required
                    :rules="[{ required: true, message: '请填写职称' }]"
                  />
                </div> -->
                <!-- <div class="formInput">
                  <van-field
                			
                    v-model="department"
                    name="department"
                    placeholder="请填写科室/部门"
                    label="科室/部门"
                    clearable
                    required
                    :rules="[{ required: true, message: '请填写科室/部门' }]"
                  />
                </div> -->
                <div class="formInput">
                  <van-field
                			
                    name="isbasiclevel"
                    label="是否来自基层（县及以下、社区等医疗卫生机构）"
                    required
                  >
                    <template #input>
                      <van-radio-group v-model="attr2.isbasiclevel" direction="horizontal">
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否">否</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                </div>
                <div class="formInput">
                  <!-- <van-field
                			
                    v-model="province"
                    name="province"
                    placeholder="请填写所属省市"
                    label="所属省市"
                    clearable
                    required
                    :rules="[{ required: true, message: '请填写所属省市' }]"
                  /> -->
                 
          		<van-field
                    v-model="attr2.province"
                    is-link
                    readonly
          		  name="province"
                    label="单位所在地（省）"
                    placeholder="请填写单位所在地（省）"
                    required
                    @click="showPicker_xf = true"
                    :rules="[{ required: true, message: '请选择单位所在地（省）' }]"
                  />
                  <van-popup v-model:show="showPicker_xf" round position="bottom">
                    <van-area title="所属省" :area-list="areaList" :columns-num="1" @confirm="onConfirmProvince_xf" @cancel="showPicker_xf = false" />
                  </van-popup>
                </div>
                <div class="formInput">
                  <van-field
                				
                    v-model="attr2.phone"
                    name="phone"
                    label="联系电话"
                    placeholder="请输入联系电话"
                    type="tel"
                    clearable
                    required
                    maxlength="11"
                    :rules="[{ pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, required: true, message: '联系电话格式错误' }]"
                  />
                </div>
                <!-- <div class="formInput">
                  <van-field
                			
                    name="islsxbfc"
                    label="是否隶属于西部12省（区、市）范畴"
                    required
                  >
                    <template #input>
                      <van-radio-group v-model="islsxbfc" direction="horizontal">
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否">否</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                </div> -->
          	  <div style="margin:30px 16px 16px;">
          	    <van-button round block type="info" native-type="submit">保存</van-button>
          	  </div>
			  <div style="margin:0 16px 16px;">
				  <van-button round block type="default" @click="fhsyb">返回</van-button>
			  </div>
          	  </van-form>
            </van-col>
          
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';	
export default {
  data() {
    return {
		meeting:'',
      meetingName: this.$cookies.get('meetingName'),
      
      // unitlocation:'',
	  attr2:{
		  name:'',
		  age:'',
		  sex:'',
		  titlegrade:'',
		  gzdw:'',
		  isbasiclevel:'',
		  province:'',
		  phone:'',
	  },
      department:'',
      islsxbfc:'',
      sqxfEndTime:localStorage.getItem('sqxfEndTime'),
      showPicker:false,
      areaList:areaList,
      showPicker_titlegrade:false,
	  showPicker_xf:false,
	  showPicker_titlegrade:false,
      columns_titlegrade:[
        {
          text: '副高及以上',
          value:'副高及以上'
        },
        {
          text:'中级',
          value:'中级'
        },
        {
          text:'初级',
          value:'初级'
        },
        {
          text:'乡村医生',
          value:'乡村医生'
        }
      ],
      IsAttr2:false,
      zsbxy:false
    };
  },
  mounted(){
    this.toEnteredCenter();
  },
  methods: {
	  fhsyb(){
		  this.$router.push('/personal/teammember?meetingCode='+this.meeting.code);
	  },
	  toEnteredCenter() {
	    const hyMeetingId = sessionStorage.getItem('meetingId');
	    const token = localStorage.getItem('sessionGrzxToken_'+hyMeetingId);
	    if (!token) {
	      this.$router.push('/personal/login?meetingId=' + hyMeetingId);
	      return false;
	    } else {
	      this.axios.get('/api/appweb/entered/toEnteredCenter/' + hyMeetingId, { headers: { Authorization: ` ${token}` } }).then(res => {
	        // console.log(res.data.data);
	        if(res.data.status == 200){
	  		  this.meeting = res.data.data.meeting;
	  		  this.$cookies.set('meetingName',res.data.data.meeting.meetingName);
			  if(res.data.data.enteredList&&res.data.data.enteredList.length>0){
				  res.data.data.enteredList.forEach((item)=>{
					  if(item.id == this.$route.query.enteredId){
						  if(item.attr2){
							  this.attr2 = JSON.parse(item.attr2);
						  }
					  }
				  })
			  }
			}
	      });
	    }
	  },
    shsq(){
      this.zsbxy = true;
    },
    onConfirm_titlegrade(value) {
      this.attr2.titlegrade = value.value;
      this.showPicker_titlegrade = false;
    },
   onConfirmProvince_xf(value) {
     this.attr2.province = value.map(item => item.name).join('/');
     this.showPicker_xf = false;
   },
    onSubmit_xf(values) {
	  if(values.sex == ""){
	    this.$toast.fail('请选择性别')
	    return false;
	  }else if(values.titlegrade == ""){
	    this.$toast.fail('请选择职称')
	    return false;
	  }else if(values.isbasiclevel == ""){
	    this.$toast.fail('请选择是否来自基层（县及以下、社区等医疗卫生机构）')
	    return false;
	  }
	  // else if(values.islsxbfc == ""){
	  //   this.$toast.fail('请选择是否隶属于西部12省（区、市）范畴')
	  //   return false;
	  // }
	  values['enteredId'] = this.$route.query.enteredId;
	  console.log(values);
	  const hyMeetingId = sessionStorage.getItem('meetingId');
	  		const token = localStorage.getItem('sessionGrzxToken_'+hyMeetingId);
	   this.axios.post('/api/appweb/entered/applyCredit/'+hyMeetingId,values,{ headers: {  Authorization: ` ${token}`  } }).then((res)=>{
	     if (res.data.status == 200) {
	  		this.$toast.success(res.data.data)
	  		setTimeout(() => {
	  		  this.$router.push('/personal/teammember?meetingCode='+this.meeting.code)
	  		}, 2000);
	     } else {
	  		this.$toast.fail(res.data.message);
	     }
	   })
    },
  }
};
</script>

<style>
.bmlcTit {
	font-size: 20px;
	font-weight: bold;
	margin-top: 0;
	margin-bottom: 20px;
	margin-left: 20px;
	margin-right: 20px;
	color: #0038b8;
	line-height: 40px;
}
.bmlcTit button{vertical-align: middle;}
.bmForm {
  padding: 20px 0;
}
.bmTitle {
  padding: 10px 20px 30px;
  line-height: 40px;
  background: url(~@/assets/images/titlebg.png) no-repeat bottom center;
  background-size:  100% 100%;
  color:#fff;
  text-align: center;
}
.bmTitle h2 {
  font-weight: normal;
  margin-bottom: 0;
}
.hide {
  display: none;
}
.formInput {
  padding: 4px 0;
  margin:0 20px;
  border-bottom: 1px solid #e8e8e8;
}
.lineddd{
  height:3px;
  background-color: #e8e8e8;
  margin-top: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/Personal/teammember/xf.vue